module.exports = __webpack_public_path__ + "5cb424fc1de8352ac8af8e6b208b690b.MP3";